export default {
    header: 'My page',
    suggestedPositions: 'Suggested positions',

    favoriteModule: {
        header: 'My favorite positions',
        seeAll: 'See all',
        noFavorites: 'You have no active favorite positions',
    },
};
